import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { Bandeira } from 'src/app/shared/models/bandeira.enum';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { ValidarCadastroRequest } from 'src/app/shared/models/validar-cadastro-request.model';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { ToastService } from 'src/app/shared/toast';
import BrowserUtils from 'src/app/shared/utils/browser-utils';
import { CadastroService } from '../cadastro.service';

const assets = {
  cb: {
    brand: 'assets/images/new-brand-cb.svg',
    brandVert: 'assets/images/login/cb-brand-vert.svg',
    brandMascot: 'assets/images/login/cb-login-section.png',
  },
  pf: {
    brand: 'assets/images/new-brand-pf.svg',
    brandVert: 'assets/images/login/pf-brand-vert.svg',
    brandMascot: 'assets/images/login/pf-login-section.png',
  }
}

enum CadastroStepEnum {
  SALVAR_DADOS = 'SALVAR_DADOS',
  CONFIRMAR_CADASTRO = 'CONFIRMAR_CADASTRO',
}

@Component({
  selector: 'app-cadastro-page',
  templateUrl: './cadastro-page.component.html',
  styleUrls: ['./cadastro-page.component.scss']
})
export class CadastroPageComponent implements OnInit {
  isCasasBahia = this.autenticacaoService.bandeira === Bandeira.CASAS_BAHIA;
  loading = false;
  isAlterarSenha: boolean;
  CadastroStepEnum = CadastroStepEnum;
  usuario: Usuario;
  cadastroStep: CadastroStepEnum = CadastroStepEnum.SALVAR_DADOS;

  constructor(
    private cadastroService: CadastroService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    private autenticacaoService: AutenticacaoService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.googleAnalyticsService.pushPageViewEvent({
      page_name: '/renegocie/cadastro',
      page_template: 'renegocie',
    }, {
      user_status_login: 'deslogado',
    });
    this.isAlterarSenha = this.router.url.split('/').some((path) => path === 'alterar-senha');
  }

  async salvar(usuario: Usuario) {
    try {
      this.loading = true;

      if (this.isCasasBahia) {
        await this.cadastroService.enviarTokenCadastro({
          nome: usuario.nome,
          cpf: usuario.cpf,
          email: usuario.email,
          telefone: usuario.telefone,
        });
      } else {
        await this.cadastroService.cadastrarClientePF(usuario);
      }

      this.cadastroStep = CadastroStepEnum.CONFIRMAR_CADASTRO;
      this.usuario = usuario
    } catch (res) {
      this.googleAnalyticsService.pushActionEvent({
        event: 'view_error',
        detail: res.error?.message || 'Erro ao efetuar cadastro'
      });

      if (res && res.error && res.error.message) {
        this.toastService.show({ type: 'error', title: res.error.message });
      } else {
        this.toastService.show({ type: 'error', title: 'Erro ao efetuar cadastro.', text: 'Por favor tente novamente mais tarde.' });
      }
    } finally {
      this.loading = false;
    }
  }

  async confirmarCadastro(validarCadastro: ValidarCadastroRequest) {
    try {
      this.loading = true;

      if (this.isCasasBahia) {
        await this.cadastroService.cadastrarClienteCB({
          ...this.usuario,
          senha: validarCadastro.senha,
          token: validarCadastro.token,
        });
      } else {
        await this.cadastroService.confirmarCadastroPF(validarCadastro, this.usuario.cpf);
      }
      this.googleAnalyticsService.pushActionEvent({
        event: 'sign_up',
        method: 'cpf',
      });
      this.toastService.show({ type: 'success', title: 'Cadastro criado com sucesso!' });
      this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
    } catch (res) {
      if (res && res.error && res.error.message) {
        this.toastService.show({ type: 'error', title: res.error.message });
      } else {
        this.toastService.show({ type: 'error', title: 'Erro ao efetuar cadastro.', text: 'Por favor tente novamente mais tarde.' });
      }
    } finally {
      this.loading = false;
    }
  }

  voltar() {
    if (this.cadastroStep === CadastroStepEnum.CONFIRMAR_CADASTRO) {
      this.usuario = null;
      this.cadastroStep = CadastroStepEnum.SALVAR_DADOS;
    } else {
      this.router.navigate(['/']);
    }
  }

  get isOldFirefox() {
    return BrowserUtils.isOldFirefox();
  }

  get assets() {
    if (this.isCasasBahia) {
      return assets.cb;
    }

    return assets.pf;
  }
}
